// extracted by mini-css-extract-plugin
export default {"FirstPage":"FirstPage_FirstPage__IxJRF","Image":"FirstPage_Image__-BdZA"};